var _style, _path, _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCmButton = function SvgCmButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 81,
    height: 17,
    x: "0px",
    y: "0px",
    viewBox: "0 0 81 17",
    style: {
      enableBackground: "new 0 0 81 17"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#68A2BC;stroke:rgb(16, 20, 28);}\n\t\t.st1{fill:#FFFFFF;}\n\t\t.st2{font-family:'MyriadPro-Regular';}\n\t\t.st3{font-size:12px;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st0",
    d: "M0.5,8.5l7.3-8h72.7v8l-6.9,8H0.5V8.5z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 16.8365 12.0331)",
    className: "st1 st2 st3"
  }, "\n\t\tConcepts\n\t")));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCmButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cm-button.51e195c4.svg";
export { ForwardRef as ReactComponent };